'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var _upload_1 = require("./_modules/_upload");
var _user_panel_1 = require("./_modules/_user_panel");
var _hamburgler_1 = require("./_modules/_hamburgler");
var _order_1 = require("./_modules/_order");
var _order_cart_1 = require("./_modules/_order_cart");
var _order_other_1 = require("./_modules/_order_other");
var _order_item_1 = require("./_modules/_order_item");
var _pricement_1 = require("./_modules/_pricement");
var _faq_1 = require("./_modules/_faq");
var _common_1 = require("./_modules/_common");
var _slick_1 = require("./_modules/_slick");
$(function () {
    new _common_1.default.MyCommon();
    new _upload_1.default.MyUpload();
    new _user_panel_1.default.MyUserPanel();
    new _hamburgler_1.default.MyHamburgler();
    new _order_1.default.MyOrder();
    new _order_cart_1.default.MyOrderCart();
    new _order_other_1.default.MyOrderOther();
    new _order_item_1.default.MyOrderItem();
    new _pricement_1.default.MyPricement();
    new _faq_1.default.MyFaq();
    new _slick_1.default.MySlick();
});
